'use strict';

var React = require('react');

var SvgCollectionFeaturedIcon = function SvgCollectionFeaturedIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 6.5c0 .552-.448 1-1 1s-1-.448-1-1 .448-1 1-1 1 .448 1 1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10.169 3c-.995 0-1.949.395-2.652 1.098l-3.883 3.883c-1.074 1.074-1.074 2.816 0 3.89l2.672 2.672c.977.976 2.56.976 3.536 0l4.206-4.206c.61-.61.952-1.437.952-2.298v-2.289c0-1.519-1.231-2.75-2.75-2.75h-2.081Zm-1.591 2.159c.422-.422.994-.659 1.59-.659h2.082c.69 0 1.25.56 1.25 1.25v2.289c0 .464-.184.909-.513 1.237l-4.206 4.206c-.39.39-1.024.39-1.414 0l-2.672-2.672c-.489-.488-.489-1.28 0-1.768l3.883-3.883Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 6.25c0-.414-.336-.75-.75-.75s-.75.336-.75.75v3.108c0 .418-.167.817-.464 1.11-.295.291-.298.766-.007 1.061.29.295.765.298 1.06.007.583-.575.911-1.36.911-2.178v-3.108Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M11.825 13.056c.706-.69 1.814-.738 2.575-.142.761-.596 1.87-.548 2.575.142.767.75.767 1.974 0 2.724l-1.7 1.664c-.487.475-1.263.475-1.75 0l-1.7-1.664c-.767-.75-.767-1.974 0-2.724Zm1.05 1.072c.174-.17.464-.17.639 0l.362.354c.291.285.757.285 1.049 0l.361-.354c.175-.17.465-.17.64 0 .165.162.165.418 0 .58l-1.526 1.493-1.526-1.493c-.165-.162-.165-.418 0-.58Z"
  }));
};
SvgCollectionFeaturedIcon.displayName = "CollectionFeaturedIcon";

exports.SvgCollectionFeaturedIcon = SvgCollectionFeaturedIcon;
